import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const Queued = new StatusEnumItem({
  id: '32c3985a-5d9d-4bdb-855c-e183480f0b3c',
  name: 'Queued',
  description: 'The request has been requested and is awaiting generation',
  priority: 0,
})
const Generating = new StatusEnumItem({
  id: 'ce1e02ce-2a81-4bb6-a9bc-ab949f2cfbeb',
  name: 'Generating',
  description:
    'The request is currently generating. There may only be 1 request generating at a time per project',
  priority: 1,
})
const Cancelled = new StatusEnumItem({
  id: '33296252-d2db-46ac-b365-54619067f125',
  name: 'Cancelled',
  description: 'The request was cancelled before it left the queue',
  priority: 2,
})
const Finished = new StatusEnumItem({
  id: 'db222504-f693-44d4-b909-0d3dca01a1a3',
  name: 'Finished',
  description: 'The request has finished generating',
  priority: 3,
})

export type QueuableRequestStatusItem =
  | typeof Queued
  | typeof Generating
  | typeof Cancelled
  | typeof Finished

class QueuableRequestStatusEnum extends StatusEnum<
  'QueuableRequestStatus',
  QueuableRequestStatusItem,
  QueuableRequestStatusItem['name'],
  QueuableRequestStatusItem['id'],
  QueuableRequestStatusItem['priority']
> {
  readonly typename = 'QueuableRequestStatus'
  get values() {
    return [this.Queued, this.Generating, this.Cancelled, this.Finished]
  }
  Queued = Queued
  Generating = Generating
  Cancelled = Cancelled
  Finished = Finished
}

/**
 * a {@link StatusEnum} for QueuableRequest entities
 */
export const QueuableRequestStatus = new QueuableRequestStatusEnum()
